var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse107(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 221,
    viewBox: "0 0 221 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 107",
    filter: "url(#filter0_d_714_4376)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.387,
    cy: 109.385,
    rx: 105.387,
    ry: 105.385,
    fill: "url(#pattern0)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_714_4376",
    x: 0,
    y: 0,
    width: 220.773,
    height: 220.77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_714_4376"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_714_4376",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_714_4376",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_714_4376",
    "data-name": "7cc66c487af201b13a89e6f1ffca1477~c5_100x100.jpg",
    width: 100,
    height: 100,
    xlinkHref: "data:image/jpeg;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse107);
export default __webpack_public_path__ + "static/media/Ellipse107.17487b5781bc4b26d3fa284a7fcbf9fc.svg";
export { ForwardRef as ReactComponent };